import styles from "./ProgressBar.module.css";
const formatter = new Intl.NumberFormat("fa-IR");

export function ProgressBar({ text, percent, className, lang }) {
  return (
    <div>
      <label className={styles.title}>{text}</label>

      <div className={className ? className : styles.progressBarContainer}>
        <div className={styles.progressBar}>
          <div
            className={styles.progressBarFill}
            style={{ width: percent + "%" }}
          ></div>
        </div>
        <label className={styles.percent}>
          {lang === "fa" ? formatter.format(percent) + "%" : percent + "%"}
        </label>
      </div>
    </div>
  );
}
